export interface UserConfig {
  cookieId: string;
  sess: string;
  mobile: string;
  email: string;
  name: string;
}

export class UserConfigManager {
  private config: UserConfig = {
    cookieId: "",
    sess: "",
    mobile: "",
    email: "",
    name: "",
  };

  private static instance: UserConfigManager | null = null;

  private constructor(initialConfig: Partial<UserConfig> = {}) {
    this.config = { ...this.config, ...initialConfig };
  }

  static create(initialConfig: Partial<UserConfig> = {}): UserConfigManager {
    if (!UserConfigManager.instance) {
      UserConfigManager.instance = new UserConfigManager(initialConfig);
    }
    return UserConfigManager.instance;
  }

  updateConfig(updates: Partial<UserConfig>): void {
    this.config = { ...this.config, ...updates };
  }

  getConfig(): Readonly<UserConfig> {
    return Object.freeze({ ...this.config });
  }

  get<K extends keyof UserConfig>(key: K): UserConfig[K] {
    return this.config[key];
  }

  set<K extends keyof UserConfig>(key: K, value: UserConfig[K]): void {
    this.config[key] = value;
  }
}

export const $user_config = UserConfigManager.create();
